import React from 'react'
import axios from 'axios'
import { useEffect, useState } from 'react'
import { useTheme as useNextTheme } from 'next-themes'
import { Switch, useTheme } from '@nextui-org/react'
import CherryK from '../../../assets/img/cherryk.png'
import { Link, useLocation } from 'react-router-dom'
import { Badge, Grid } from '@nextui-org/react'

import {
    FaFileMedical,
    FaDatabase,
    FaProductHunt,
    FaPowerOff,
    FaImages
} from 'react-icons/fa'
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { logoutSuccess } from '../../../redux/authRedux'
import Swal from 'sweetalert2'

function SideBar() {
    const token = localStorage.getItem('token')
    const url = process.env.REACT_APP_APP_URL
    const api = axios.create({
        baseURL: url,
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
        }
    })

    const location = useLocation()
    const [accHOCount, setAccHOCount] = useState('')
    const [medHOCount, setMedHOCount] = useState('')
    const [proHOCount, setProHOCount] = useState('')
    const { setTheme } = useNextTheme()
    const { isDark, type } = useTheme()

    const [accountLists, setAccountLists] = useState([])
    const [count, setCount] = useState('')
    const [stockReqLists, setStockReqLists] = useState([])
    const [reqCount, setReqCount] = useState('')
    const [stockTranLists, setStockTranLists] = useState([])
    const [tranCount, setTranCount] = useState('')

    const user = useSelector(state => state.auth.user)
    console.log(user?.user?.role, 'role')
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const logout = () => {
        Swal.fire({
            title: 'Success',
            text: 'successfully Logout!',
            icon: 'success',
            showConfirmButton: false,
            timer: 2000
        }).then(function () {
            dispatch(logoutSuccess())
            navigate('/')
        })
    }
    const divStyles = {
        boxShadow: '1px 2px 9px #BBB9B9',
        height: '930px',
    }



    return (
        <aside className='menu main-sidebar rounded' style={divStyles}>

            <img src={CherryK} alt='' width='210px' height='130px' />

            {/* 
            <!-- Sidebar --> */}
            <div className='sidebar mt-2'>
                <nav className='mt-3'>
                    <ul className='nav sidebar-nav nav-pills nav-sidebar flex-column overflow-hidden flex gap-2'>
                        {/* //admin */}

                        <li className={location.pathname.split('-')[0] === '/treatment' ? 'nav-item bg-primary p-1 rounded-lg' : 'nav-item'}>
                            <Link to='/treatment-dashboard' className=' text-dark'>

                                <FaDatabase />
                                <span className='ml-2'>Treatments</span>
                            </Link>
                        </li>
                        <li className={location.pathname.split('-')[0] === '/promotion' ? 'nav-item bg-primary p-1 rounded-lg' : 'nav-item'}>
                            <Link to='/promotion' className=' text-dark'>

                                <FaProductHunt />
                                <span className='ml-2'>Promotions</span>
                            </Link>
                        </li>
                        <li className={location.pathname.split('-')[0] === '/banner' ? 'nav-item bg-primary p-1 rounded-lg' : 'nav-item'}>
                            <Link to='/banner' className=' text-dark'>

                                <FaImages />
                                <span className='ml-2'>Banner</span>
                            </Link>
                        </li>

                        <li className='nav-item ' style={{ marginTop: '600px' }}>
                            <a className='nav-link' onClick={logout}>
                                <button className='btn btn-sm btn-outline-info'>
                                    <FaPowerOff />

                                    <span className='ml-2'>Logout</span>
                                </button>

                            </a>
                        </li>

                        <li className='nav-item'>
                            {/* The current theme is: {type}
              <Switch
                checked={isDark}
                onChange={e => setTheme(e.target.checked ? 'dark' : 'light')}
              /> */}
                            {/* <Link
                to="http://clinicdenovopos.kwintechnologies.com/dashboard"
                className="nav-link ">
                <p>
                  <FaCashRegister /> &nbsp; POS
                </p>
              </Link> */}
                        </li>
                        {/* <li className='nav-item'>
              <a href='' className='nav-link'>
                <p>
                  &nbsp;Logout
                </p>
              </a>
            </li> */}
                    </ul>
                </nav>
                {/* <!-- /.sidebar-menu --> */}
            </div>
            {/* <!-- /.sidebar --> */}
        </aside>
    )
}
export default SideBar
